import "../css/Panel.css";
import "../css/Patient.css";
import "../css/PatientSearch.css";
import "../css/custom-datatable.css";
import "../css/Dashboard.css";
import "../css/CRM.css";
import { useEffect, useState } from "react";
import ButtonIconH from "../components/ButtonIconH";
import { CRMSummaryBox } from "../components/CRMSummaryBox";
import { CRMCampaigns } from "../components/CRMCampaigns";
import { CRMLists } from "../components/CRMLists";
import { AutoSend } from "../components/AutoSend";
import { userData } from "../js/utils";
import { post } from "../js/post";
import { HistoryCRM } from "../components/CRMHistory";

export default function CRM({ show }) {
  const [CRMSummary, setCRMSummary] = useState(null);
  const [selectedOption, setSelectedOption] = useState({
    campanas: true,
    listas: false,
    autosend: false,
    historial: false,
  });

  async function getCRMSummary() {
    const response = await post("support-extra/crm/ObtenerResumenCRM.php", {
      token: userData.token,
    });
    setCRMSummary(response);
  }

  function handleActiveOption(key) {
    setSelectedOption((prev) =>
      Object.keys(prev).reduce((acc, curr) => {
        acc[curr] = curr === key;
        return acc;
      }, {}),
    );
  }

  useEffect(() => {
    getCRMSummary();
  }, []);

  if (!show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      <div className="patient-data-header">
        <span className="header-text">CRM</span>
      </div>
      <div
        className="patient-data-content crm-content"
        style={{ paddingBottom: 20 }}
      >
        <div className="action-bar">
          <div className="action-bar-resume">
            <span className="signed-text">CRM</span>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <div className="dashboard-content">
            <div className="patient-search-content dashboard-bg">
              <div className="opt-table-title" style={{ marginBottom: 0 }}>
                Pacientes únicos/Comunicaciones
              </div>
              <div className="dashboard-content-data">
                {CRMSummary && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      gap: 40,
                    }}
                  >
                    <CRMSummaryBox
                      title="Campañas realizadas"
                      data={CRMSummary.campanas}
                    />
                    <CRMSummaryBox
                      title="Pacientes alcanzados"
                      data={CRMSummary.clientesAlcanzados}
                    />
                    <CRMSummaryBox
                      title="Ventas motivadas"
                      sales={true}
                      data={CRMSummary.ventasMotivadas}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="dashboard-content">
            <div className="patient-search-content dashboard-bg">
              <div
                className="dashboard-content-data"
                style={{ alignItems: "center" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <ButtonIconH
                    text="Campañas"
                    selected={selectedOption.campanas}
                    onClick={() => {
                      handleActiveOption("campanas");
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="Listas"
                    selected={selectedOption.listas}
                    onClick={() => {
                      handleActiveOption("listas");
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="AutoSend"
                    selected={selectedOption.autosend}
                    onClick={() => {
                      handleActiveOption("autosend");
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="Historial"
                    selected={selectedOption.historial}
                    onClick={() => {
                      handleActiveOption("historial");
                    }}
                  ></ButtonIconH>
                </div>
                {selectedOption.campanas && <CRMCampaigns />}
                {selectedOption.listas && <CRMLists />}
                {selectedOption.autosend && <AutoSend />}
                {selectedOption.historial && <HistoryCRM />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
